import React from 'react';
import YetAnotherReactLightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

export interface LightboxImage {
  src: string;
  alt?: string;
  title?: string;
  description?: string;
}

export interface LightboxProps {
  isOpen: boolean;
  onClose: () => void;
  images: LightboxImage[];
  currentIndex?: number;
}

const Lightbox: React.FC<LightboxProps> = ({
  isOpen,
  onClose,
  images,
  currentIndex = 0,
}) => {
  const slides = images.map((image) => ({
    src: image.src,
    alt: image.alt || '',
    title: image.title,
    description: image.description,
  }));

  return (
    <YetAnotherReactLightbox
      open={isOpen}
      close={onClose}
      slides={slides}
      index={currentIndex}
      styles={{
        container: {
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
        },
      }}
    />
  );
};

export default Lightbox;